export const jobMap: { [index: string]: string } = {
  ADMIN: 'Администратор',
  PROSECUTOR: 'Прокурор',
  SUPERIOR_PROSECUTOR: 'Вышестоящий прокурор',
  SUPERVISOR: 'Работник КНО',
  OMBUDSMAN: 'Омбудсмен / Наблюдатель',
};
